import template from './template.jpg'
import  jordanlawyer from './jordanlawyer.jpg'
import  jeffreylawyer from './jeffreylawyer.jpg'
import  veenalawyer from './veenalawyer.jpg'
import  scherlawyer from './scherlawyer.png'
import  justinlawyer from './justinlawyer.jpg'
import  millslawyer from './millslawyer.png'
import  pollocklawyer from './pollocklawyer.jpg'
import  sanjalawyer from './sanjalawyer.jpg'
import  bryanlawyer from './bryanlawyer.png'
import  picovlawyer from './picovlawyer.jpg'

export const LawyersData = [
    {img:  jordanlawyer, 
    name: "Jordan D Sobel",
    about: "Practicing predominantly in the areas of civil, commercial, construction, estate, motor vehicle accident and family law litigation, the Law Offices of Jordan D. Sobel, B.Comm., LL.B., Barrister, Solicitor and Notary Public have been voted as 'Top 5 Lawyers' in Toronto by one of the largest circulated newspaper publications in Canada.",
    location: "55 Eglinton Avenue E Suite 706 Toronto, ON M4P 1G8",
    number: "+1 (416) 915-0622",
    },
    {img: jeffreylawyer , 
    name: "Jeffrey Perlmutter - Perlmutter Law",
    about: "Perlmutter Law practices exclusively in the areas of personal injury litigation and insurance litigation. We value excellence in client communication, and excellence of service. Mr. Perlmutter acts in a variety of personal injury/insurance dispute matters such as:  motor vehicle accidents  coverage disputes  occupiers' liability - such as slip & falls  product liability  disability claims",
    location: "36 Toronto Street Suite 850 Toronto, ON M5C 2C5",
    number: "+1 (416) 304-1370",
    },
    {img: veenalawyer , 
    name: "Veena Pohani & Associates",
    about: "Practicing family, health care law, and bankruptcy law. Complex property matters. Serving my community one day at a time. Proud to be a South Asian delivering service to my community.",
    location: "57 Benleigh Drive Toronto, ON M1H 1J4",
    number: "+1 (416) 900-5599",
    },
    {img: scherlawyer , 
    name: "Scher Law",
    about: "Located in Toronto, also available with virtual video and conference calls, Scher Law PC is dedicated to providing sound legal advice in the areas of employment law, human rights law and disability law. We also handle civil litigation claims, harassment law, health law claims, insurance claims, personal injury claims and academic law claims. Call Scher Law PC and get reliable legal advice today.",
    location: "1200 Bay Street Suite 604 Toronto, ON M5R 2A5",
    number: "+1 (416) 515-9686",
    },
    {img: justinlawyer , 
    name: "Justin W. Anisman",
    about: "Justin W. Anisman focuses his practice exclusively in the area of employment and civil litigation. His law practice is based in the heart of the Financial District of Toronto but he advises clients across Ontario. Justin can help you with all types of employment law disputes, including: * Wrongful Dismissal * Constructive Dismissal * Human Rights Justin offers free consultations to new clients. If he believes you have a good case then he may offer to take it on a contingency fee. This means that if you do not win or settle the case, you do not have to pay. He is in the business of taking on good cases but if he does not believe that you have one, he won't charge you for saying so.",
    location: "161 Bay Street Suite 2900 Toronto, ON M5J 2S1",
    number: "+1 (416) 833-8443",
    },
    {img: millslawyer , 
    name: "Mills & Mills",
    about: "Mills & Mills LLP provides services in the following areas: Administrative Law, Business (Commercial) Law, Charitable and Not-For-Profit Organizations, Church Law, Civil Litigation, Corporate Law, Design Law, Employment Law, Family Law, Freedom of Information and Privacy Law, Health Law, Insurance Law, Intellectual Property, Loan Transactions, Real Estate, Wills, Estates and Trusts.",
    location: "2 St Clair Avenue W Suite 1700 Toronto, ON M4V 1L5",
    number: "+1 (416) 863-0125",
    },
    {img: pollocklawyer , 
    name: "Pollock & Pollock Barristers",
    about: "Pollock & Pollock Barristers, a distinguished legal duo, skillfully navigate the complexities of the law to secure justice for their clients.",
    location: "2323 Yonge Street Toronto, ON M4P 2C9",
    number: "+1 (416) 488-5323",
    },
    {img: sanjalawyer , 
    name: "Sanja Mavrak, Barrister & Solicitor",
    about: "Sanja Mavrak represents individuals in Toronto and the GTA facing all types of criminal charges, as well as individuals and small businesses facing various types of contractual and civil litigation issues.",
    location: "43 Front Street East 4th Floor Toronto, ON M5E 1B3",
    number: "+1 (416) 554-4974",
    },
    {img: bryanlawyer , 
    name: "Bryan Carvalho Law Office",
    about: "I am a small business lawyer practising in Toronto, Ontario. I assist clients with the following: - Starting a business - Purchasing a business - Sale of a business - Drafting of shareholder and partnership agreements - Drafting of commercial agreements - Drafting of employment agreements - Leasing of equipment and commercial spaces - Assistance with small business needs generally",
    location: "905 College Street Toronto, ON M6H 1A1",
    number: "+1 (416) 841-4200",
    },
    {img: picovlawyer , 
    name: "Picov, Kleinberg",
    about: "Picov & Kleinberg: Barristers & Solicitors in Toronto are focused on providing you with strong legal representation. We specialize in the areas of business law, estate law, real estate law and wills. We offer legal representation in English, Cantonese and Mandarin, for your convenience. Please call Picov & Kleinberg: Barristers & Solicitors for a consultation.",
    location: "110 Eglinton Avenue West Toronto, ON M4R 1A3",
    number: "+1 (416) 488-2100",
    }
]